import { useElementVisibility, ELEMENTS } from './useIsElementVisible';
import { useContentLabels } from './useContentLabels';

export const useCanEditLabels = () => {
	const { isElementVisible } = useElementVisibility();
	const { data } = useContentLabels();
	const { hasEditPermissions } = data;
	return {
		isLabelsAvailable: isElementVisible(ELEMENTS.ROWS.LABELS),
		canEditLabels: hasEditPermissions,
	};
};
